/**
 * 위젯 레지스트리 — 신규 위젯은 여기에만 등록하면 전역 사용 가능
 *
 * Phase 0: index-pulse (3대 지수)
 * Phase 1: + watchlist-mini, news-brief, sector-heatmap, fx-rate, fear-greed,
 *          macro-pulse, earnings-calendar, economic-calendar
 * Phase 2: + market-brief (AI), today-movers (AI), ai-headline (AI),
 *          news-ai-summary (AI), earnings-calls-ko (AI)
 * Phase 3: + my-tickers (개인화), portfolio-pnl, calls-dday, ai-qa
 * Phase 4: + ai-signal (premium)
 */
import type { WidgetMeta, WidgetType } from "./types";
import { indexPulseMeta } from "./widgets/index-pulse";
import { marketBriefMeta } from "./widgets/market-brief";
import { companyInfoMeta } from "./widgets/company-info";
import { marketNewsMeta } from "./widgets/market-news";
import { earningsCalendarMeta } from "./widgets/earnings-calendar";
import { economicCalendarMeta } from "./widgets/economic-calendar";
import { fearGreedMeta } from "./widgets/fear-greed";
import { sectorMapMeta } from "./widgets/sector-map";
import { watchlistMeta } from "./widgets/watchlist";
import { fxRateMeta } from "./widgets/fx-rate";
import { macroRatesMeta } from "./widgets/macro-rates";
import { moversMeta } from "./widgets/movers";
import { highsLowsMeta } from "./widgets/highs-lows";
import { cryptoMeta } from "./widgets/crypto";
import { commoditiesMeta } from "./widgets/commodities";
import { earningsSurpriseMeta } from "./widgets/earnings-surprise";
import { volumeLeadersMeta } from "./widgets/volume-leaders";

const REGISTRY: Record<WidgetType, WidgetMeta> = {
  "index-pulse": indexPulseMeta,
  "market-brief": marketBriefMeta,
  "company-info": companyInfoMeta,
  "market-news": marketNewsMeta,
  "earnings-calendar": earningsCalendarMeta,
  "economic-calendar": economicCalendarMeta,
  "fear-greed": fearGreedMeta,
  "sector-map": sectorMapMeta,
  "watchlist": watchlistMeta,
  "fx-rate": fxRateMeta,
  "macro-rates": macroRatesMeta,
  "movers": moversMeta,
  "highs-lows": highsLowsMeta,
  "crypto": cryptoMeta,
  "commodities": commoditiesMeta,
  "earnings-surprise": earningsSurpriseMeta,
  "volume-leaders": volumeLeadersMeta,
};

export function getWidgetMeta(type: WidgetType): WidgetMeta | null {
  return REGISTRY[type] ?? null;
}

export function getAllWidgets(): WidgetMeta[] {
  return Object.values(REGISTRY);
}

export function getWidgetsByCategory(category: WidgetMeta["category"]): WidgetMeta[] {
  return Object.values(REGISTRY).filter((w) => w.category === category);
}
